import "../Main.css";
import Calendar from "react-calendar";
import moment from "moment";

const ReportCalendar = (props) => {
  const { userLevel, calendarValue, statusMessage } = props;

  const onDateChange = (date) => {
    console.log(date);

    const clickedTile = moment(date).format("YYYY-MM-DD");
    const today = moment(new Date()).format("YYYY-MM-DD");

    const dayNumber = moment(date).weekday();

    if (dayNumber === 6 || dayNumber === 0) {
      window.alert("휴일에는 작성할 수 없습니다.");
    } else if (clickedTile > today) {
      window.alert("오늘보다 이후 날짜 보고서는 작성할 수 없습니다.");
    } else {
      if (userLevel < 2) {
        window.location.href = "/admin?date=" + clickedTile;
      } else {
        window.location.href = "/report?date=" + clickedTile;
      }
    }
  };

  return (
    <>
      <div style={{ width: "90%", padding: 20 }}>
        <h2 style={{ marginTop: "50px" }}>Daily Report Calendar</h2>
        {/* <Link style={{color:'white'}} to='/logout'><h6 style={{display:'flex', justifyContent:'flex-end'}}>{userName}</h6></Link> */}
      </div>
      <div style={{ width: "90%", backgroundColor: "yellow" }}>
        <Calendar
          calendarType="US"
          onChange={onDateChange}
          onActiveStartDateChange={(date) => console.log(date)}
          value={calendarValue}
          formatDay={(locale, date) => moment(date).format("DD")}
        />
        <div
          style={{
            display: "table",
            width: "100%",
            backgroundColor: "red",
            textAlign: "left",
            fontSize: 12,
            height: 20,
          }}
        >
          {statusMessage}
        </div>
      </div>
    </>
  );
};

export default ReportCalendar;
